module.exports = __webpack_public_path__ + "img/weather53.ce3d42eb.png";